<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="tochead">Contents</p>
<p class="toc"><a href="#/chap01"><span class="spa">  1</span>The Genius of Gabriel Toller</a></p>
<p class="toc"><a href="#/chap02"><span class="spa">  2</span>George Henry’s Black Eye</a></p>
<p class="toc"><a href="#/chap03"><span class="spa">  3</span>Hand Over Mouth</a></p>
<p class="toc"><span href="#/chap04" title="Link target outside of Sample"><span class="spa">  4</span>All Shapes and Sizes</span></p>
<p class="toc"><span href="#/chap05" title="Link target outside of Sample"><span class="spa">  5</span>Mr. Rutter and Others</span></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample"><span class="spa">  6</span>Enter Maurice</span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample"><span class="spa">  7</span>‘Tomorrow, Here’</span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample"><span class="spa">  8</span>Police for Polly</span></p>
<p class="toc"><span href="#/chap09" title="Link target outside of Sample"><span class="spa">  9</span>Gordon Craigie</span></p>
<p class="toc"><span href="#/chap10" title="Link target outside of Sample"><span class="spa">10</span>Beneath the Bridge</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample"><span class="spa">11</span>Landslide</span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample"><span class="spa">12</span>Monkey-tricks</span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample"><span class="spa">13</span>‘Chineside’</span></p>
<p class="toc"><span href="#/chap14" title="Link target outside of Sample"><span class="spa">14</span>The Hard Job</span></p>
<p class="toc"><span href="#/chap15" title="Link target outside of Sample"><span class="spa">15</span>Paula Bentley</span></p>
<p class="toc"><span href="#/chap16" title="Link target outside of Sample"><span class="spa">16</span>More Moves in Bournemouth</span></p>
<p class="toc"><span href="#/chap17" title="Link target outside of Sample"><span class="spa">17</span>The Disappearance of ‘Thomas’</span></p>
<p class="toc"><span href="#/chap18" title="Link target outside of Sample"><span class="spa">18</span>Gertrude Ryall</span></p>
<p class="toc"><span href="#/chap19" title="Link target outside of Sample"><span class="spa">19</span>Power Politics</span></p>
<p class="toc"><span href="#/chap20" title="Link target outside of Sample"><span class="spa">20</span>Mr. Rutter’s Triumph</span></p>
<p class="toc"><span href="#/chap21" title="Link target outside of Sample"><span class="spa">21</span>Empty House</span></p>
<p class="toc"><span href="#/chap22" title="Link target outside of Sample"><span class="spa">22</span>The Triumph of George</span></p>
<p class="toc"><span href="#/chap23" title="Link target outside of Sample"><span class="spa">23</span>The Professor with Nine Lives</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?42d4d00e